/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';
import {
  Table,
  TableHead,
  Row,
  NormalTableHeader,
  MediumTableHeader,
  SmallTableHeader,
  TableBody,
  NormalTableCell,
  MediumTableCell,
  SmallTableCell,
  Icon,
  ScrollWrapper,
  MyPaginate,
  PaginateButton,
  IconWrapper,
} from './waitlistTableElements';
import useAxiosPrivate from '../../../Hooks/useAxiosPrivate';
import useTable from '../../../Hooks/useTable';
import useDeviceDetect from '../../../Hooks/checkDevice';
import Popup from '../../popup/popup';
import EditWaitlistPopup from '../../popup/editWaitlist/editWaitlistPopup';

const WaitlistTable = ({
  data, setData, rowsPerPage, referrers,
}) => {
  const axiosPrivate = useAxiosPrivate();
  const { isMobile } = useDeviceDetect();

  const [page, setPage] = useState(1);
  const { slice, range } = useTable(data, page, rowsPerPage);

  const [editOpen, setEditOpen] = useState(false);
  const [selected, setSelected] = useState({});

  const removeUser = (wallet) => {
    const confirmed = window.confirm('Are you sure to remove?');
    if (!confirmed) return;

    axiosPrivate.post(
      '/removeWaitlist',
      JSON.stringify({
        wallet,
      }),
      {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.status !== 'success') return console.log('Error removing member');
      const newData = data.filter((item) => item.Wallet !== wallet);
      return setData(newData);
    });
  };

  return (
    <>
      <Popup header="Edit waitlist member" trigger={editOpen} setOpen={setEditOpen}>
        <EditWaitlistPopup
          setOpen={setEditOpen}
          trigger={editOpen}
          selected={selected}
          setData={setData}
          data={data}
          referrers={referrers}
        />
      </Popup>
      <ScrollWrapper>
        <Table>
          <TableHead>
            <Row>
              <SmallTableHeader>ID</SmallTableHeader>
              <NormalTableHeader>Wallet</NormalTableHeader>
              <NormalTableHeader>Email</NormalTableHeader>
              <MediumTableHeader>BusinessName</MediumTableHeader>
              <MediumTableHeader>Industry</MediumTableHeader>
              <MediumTableHeader>ContactName</MediumTableHeader>
              <MediumTableHeader>Phone</MediumTableHeader>
              <MediumTableHeader>Twitter</MediumTableHeader>
              <MediumTableHeader>Discord</MediumTableHeader>
              <NormalTableHeader>Notes</NormalTableHeader>
              <MediumTableHeader>Date</MediumTableHeader>
              <MediumTableHeader>Referrer</MediumTableHeader>
              <SmallTableHeader>Amount</SmallTableHeader>
              <SmallTableHeader>Action</SmallTableHeader>
            </Row>
          </TableHead>
          <TableBody>
            {slice.map((item, index) => (
              <Row dark={index % 2 === 1} key={item.idWaitlist}>
                <SmallTableCell data-label="ID">{item.idWaitlist}</SmallTableCell>
                <NormalTableCell data-label="Wallet">{item.Wallet}</NormalTableCell>
                <NormalTableCell data-label="Email">{item.Email}</NormalTableCell>
                <MediumTableCell data-label="BusinessName">{item.BusinessName}</MediumTableCell>
                <MediumTableCell data-label="Industry">{item.Industry}</MediumTableCell>
                <MediumTableCell data-label="ContactName">{item.ContactName}</MediumTableCell>
                <MediumTableCell data-label="Phone">{item.Phone}</MediumTableCell>
                <MediumTableCell data-label="Twitter">{item.Twitter}</MediumTableCell>
                <MediumTableCell data-label="Discord">{item.Discord}</MediumTableCell>
                <NormalTableCell data-label="Notes">{item.Notes}</NormalTableCell>
                <MediumTableCell data-label="Date">{(item.Date)?.split('T')[0]}</MediumTableCell>
                <MediumTableCell data-label="Referrer">{item.Referrer}</MediumTableCell>
                <SmallTableCell data-label="Amount">{item.Amount}</SmallTableCell>
                <SmallTableCell>
                  <IconWrapper>
                    <Icon
                      onClick={() => removeUser(item.Wallet)}
                    >
                      <AiFillDelete />
                    </Icon>
                    <Icon
                      edit
                      onClick={(e) => { setEditOpen(true); setSelected(item); }}
                    >
                      <AiFillEdit />
                    </Icon>
                  </IconWrapper>
                </SmallTableCell>
              </Row>
            ))}
          </TableBody>
        </Table>
      </ScrollWrapper>
      <MyPaginate
        breakLabel={isMobile ? '' : '...'}
        onPageChange={(e) => setPage((e.selected) + 1)}
        pageRangeDisplayed={isMobile ? 1 : 2}
        marginPagesDisplayed={isMobile ? 1 : 2}
        pageCount={range.length}
        renderOnZeroPageCount={null}
        nextLabel={(
          <PaginateButton>
            <MdArrowForward />
          </PaginateButton>
        )}
        previousLabel={(
          <PaginateButton>
            <MdArrowBack />
          </PaginateButton>
        )}
      />
    </>
  );
};

export default WaitlistTable;
